export class Crm {
  protected type: string;

  getTypeString() {
    return this.type;
  }
}
